export const categoryPageId = {
  hearts: 'hearts',
  music: 'music',
  math: 'math',
  arrows: 'arrows',
  currencies: 'currencies',
  smileys: 'smileys',
  weather: 'weather',
  numerals: 'numerals',
  stars: 'stars',
};

export enum PAGE_TYPE {
  symbols,
  category,
}
